import type { ProductDummyRoomFormModel } from "../type";

type Props = {
	hotelID: string;
	roomID: string;
};

export const DEFAULT_PRODUCT_DUMMY_ROOM_INPUT_MODEL = ({ hotelID, roomID }: Props) => {
	const inputModel: ProductDummyRoomFormModel["InputModel"] = {
		hotelID,
		roomID,

		name: "",

		availablePlanIDs: [],

		capacityAdultMaximum: 1,
		capacityKidsMaximum: 0,
		capacityPeopleMaximum: 1,
		catchCopy: "",
		description: "",
		inSale: false,
		isKidsUnavailable: false,
		keyVisuals: [],
		kidsPolicy: undefined,
		mainKeyVisual: { bucket: "", key: "", region: "", mimeType: null, fileName: null },
		maxRoomNum: 1,
	} satisfies ProductDummyRoomFormModel["InputModel"];

	return inputModel;
};
